import { showErrorToast } from '@amigoapp/doca-react';
import React, { useCallback, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { getQuestionary } from '../../processes/anesthetist-questionary';
import { useAnswersStore, useCompanyStore } from '../../stores';
import { WindowDimensionsUtils } from '../../utils';
import AnesthetistQuestionaryForm from './AnesthetistQuestionaryForm';

const AnesthetistQuestionaryFormContainer = () => {
	const {
		companySettings: { settings }
	} = useCompanyStore();
	const { answers, appendAnswers } = useAnswersStore();
	const history = useHistory();

	const [questionaryFields, setQuestionaryFields] = useState(null);
	const [loading, setLoading] = useState(true);
	const [values, setValues] = useState({});
	const [weight, setWeight] = useState('');
	const [height, setHeight] = useState('');
	const dimensions = WindowDimensionsUtils.useWindowDimensions();

	const isMobile = dimensions?.width < 600;

	useEffect(() => {
		if (answers?.questionary) {
			const initialValues = answers.questionary.reduce((acc, field) => {
				acc[field.key] = field.value;
				return acc;
			}, {});
			setValues(initialValues);
		}

		if (answers?.patient_changes) {
			setHeight('');
			setWeight('');
		}
	}, [answers?.questionary, answers?.patient_changes]);

	const getQuestionaryFields = useCallback(async () => {
		setLoading(true);

		const { data, error } = await getQuestionary();

		if (error) {
			showErrorToast('Não foi possível carregar o questionário.');
		} else {
			setQuestionaryFields(data);
		}

		setLoading(false);
	}, []);

	useEffect(() => {
		getQuestionaryFields();
	}, [getQuestionaryFields]);

	const handleToggleField = useCallback((key) => {
		setValues((prev) => ({
			...prev,
			[key]: !prev[key]
		}));
	}, []);

	const handleWeightChange = useCallback((e) => {
		const value = e.target.value;
		if (value === '') {
			setWeight('');
			return;
		}

		const numericValue = value.replace(/[^\d]/g, '');

		const formattedValue = (numericValue / 100).toFixed(2).replace('.', ',');

		if (parseFloat(formattedValue.replace(',', '.')) <= 500) {
			setWeight(formattedValue);
		}
	}, []);

	const handleHeightChange = useCallback((e) => {
		const value = e.target.value;
		if (value === '' || (value >= 0 && value <= 300)) {
			setHeight(value);
		}
	}, []);

	const handleSubmit = useCallback(async () => {
		const answeredQuestionary = questionaryFields.map((field) => ({
			type: field.type,
			key: field.key,
			label: field.label,
			value: values[field.key] || false
		}));

		const patientChanges = {
			height: height || null,
			weight: weight ? parseFloat(weight.replace(',', '.')) : null
		};

		appendAnswers({
			questionary: answeredQuestionary,
			patient_changes: patientChanges
		});

		history.push(`/anesthetist-signature`);
	}, [values, questionaryFields, appendAnswers, history, height, weight]);

	const handleSkip = useCallback(() => {
		history.push(`/scheduled-succesfully?token=${localStorage.getItem('token')}`);
	}, [history]);

	return (
		<AnesthetistQuestionaryForm
			loading={loading}
			questionaryFields={questionaryFields}
			values={values}
			onToggleField={handleToggleField}
			variant={settings?.theme?.name}
			patient={answers?.patient}
			onSubmit={handleSubmit}
			onSkip={handleSkip}
			weight={weight}
			height={height}
			onWeightChange={handleWeightChange}
			onHeightChange={handleHeightChange}
			isMobile={isMobile}
		/>
	);
};

export default AnesthetistQuestionaryFormContainer;
